export default 'Your entry isn\'t a valid increment.';